import script from "./DatasetCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetCard.vue?vue&type=script&setup=true&lang=ts"

import "./DatasetCard.vue?vue&type=style&index=0&id=025f3082&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-025f3082"]])

export default __exports__